import { connect } from 'react-redux'
import UI from './UI'

const mapStateTopProps = ({ course }) => ({
  LearningPaths: course.CoursePaths,
  loading: course.gettingCoursesInfos
})

export default connect(mapStateTopProps, null)(UI)
